import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Icon from './Icon';
import './ModalRetouver.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function ModalRetouver({ ouvert, fermer }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState('email');
  const [email, setEmail] = useState('');
  const [numero, setNumero] = useState('');
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');
  const [commandesTrouvees, setCommandesTrouvees] = useState([]);

  if (!ouvert) return null;

  async function rechercherCommande() {
    setChargement(true);
    setErreur('');
    setCommandesTrouvees([]);
    try {
      const params = mode === 'email'
        ? { email: email.trim() }
        : { numero_conf: numero.trim().toUpperCase() };
      const { data } = await axios.get(`${API}/api/public/retrouver-commande`, { params });

      if (data.redirect && data.token) {
        navigate(`/commande?token=${data.token}`);
        fermer();
        return;
      }

      const liste = Array.isArray(data.commandes) ? data.commandes : [];
      setCommandesTrouvees(liste);
      if (liste.length === 0) setErreur('404');
    } catch (err) {
      if (err.response?.status === 429) {
        setErreur('Trop de tentatives. Réessayez dans une minute.');
      } else if (err.response?.status === 404) {
        setErreur('404');
      } else {
        setErreur(err.response?.data?.error || 'Erreur lors de la recherche.');
      }
    } finally {
      setChargement(false);
    }
  }

  function ouvrirCommande(token) {
    navigate(`/commande?token=${token}`);
    fermer();
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') rechercherCommande();
  }

  return (
    <div className="mr-backdrop" onClick={fermer}>
      <div className="mr-card" onClick={e => e.stopPropagation()}>

        {/* Fermer */}
        <button className="mr-close" onClick={fermer} aria-label="Fermer">
          <Icon name="fermer" size={16} weight="bold" color="currentColor" />
        </button>

        {/* Titre */}
        <div className="mr-titre-bloc">
          <Icon name="recherche" size={20} weight="bold" color="var(--accent)" />
          <h2 className="mr-titre">Retrouver ma commande</h2>
        </div>
        <p className="mr-sous-titre">
          Entrez votre courriel ou numéro de confirmation
        </p>

        {/* Tabs */}
        <div className="mr-tabs">
          <button
            className={`mr-tab${mode === 'email' ? ' mr-tab-actif' : ''}`}
            onClick={() => { setMode('email'); setErreur(''); }}
          >
            <Icon name="email" size={13} weight="regular" color="currentColor" />
            Par courriel
          </button>
          <button
            className={`mr-tab${mode === 'numero' ? ' mr-tab-actif' : ''}`}
            onClick={() => { setMode('numero'); setErreur(''); }}
          >
            <Icon name="billet" size={13} weight="regular" color="currentColor" />
            Par numéro
          </button>
        </div>

        {/* Champ */}
        {mode === 'email' ? (
          <div className="mr-field">
            <label className="mr-label">Adresse courriel</label>
            <input
              type="email"
              className="mr-input"
              placeholder="marie@courriel.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>
        ) : (
          <div className="mr-field">
            <label className="mr-label">Numéro de confirmation</label>
            <input
              type="text"
              className="mr-input"
              placeholder="ESC-2026-047"
              value={numero}
              onChange={e => setNumero(e.target.value.toUpperCase())}
              onKeyDown={handleKeyDown}
              autoFocus
            />
            <p className="mr-field-note">
              Format : ESC-AAAA-XXX — indiqué dans votre courriel de confirmation
            </p>
          </div>
        )}

        {/* Erreur */}
        {erreur && (
          <div className="mr-erreur">
            <Icon name="erreur" size={14} weight="fill" color="currentColor" />
            {erreur === '404'
              ? <>Aucune commande trouvée. Vérifiez vos informations ou écrivez-nous à{' '}
                  <a href="mailto:info@escamel.ca">info@escamel.ca</a></>
              : erreur
            }
          </div>
        )}

        {/* Bouton */}
        <button
          className="mr-btn-submit"
          onClick={rechercherCommande}
          disabled={chargement}
        >
          {chargement ? (
            <span className="mr-spinner" />
          ) : (
            <>
              <Icon name="recherche" size={15} weight="bold" color="currentColor" />
              Voir ma commande
            </>
          )}
        </button>

        {/* Plusieurs commandes */}
        {commandesTrouvees.length > 1 && (
          <div className="mr-commandes-liste">
            <p className="mr-commandes-titre">Plusieurs commandes trouvées :</p>
            {commandesTrouvees.map(cmd => (
              <button
                key={cmd.token}
                className="mr-commande-item"
                onClick={() => ouvrirCommande(cmd.token)}
              >
                <span className="mr-commande-numero">{cmd.numero_conf}</span>
                <span className="mr-commande-ev">{cmd.evenement_nom}</span>
                <span className="mr-commande-detail">
                  {cmd.date_event} · {cmd.slot_pickup}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
